import React, { useEffect, useState } from 'react';
import Modal from '../../Modal';
import LenderUgroService from '../../../services/lender';
import MasterDataService from '../../../services/master-data';
import { Context } from '../../../config/store';
import { toast } from 'react-toastify';
import message from '../../../constant/message';
import { objectsForEach } from '../../../common/objectToArray';
import splitUnderscoreToCaptialise from '../../../common/splitUnderscoreToCaptialise';
import './style.css'
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import BREhelper from '../../Common/BREhelper';
import ReactTooltip from 'react-tooltip';

const AssignLenderLeadModal = ({
	modelState,
	toggleModal,
	reloadTable,
	selectedIds,
	type,
	bulkAssign,
	leadType,
	getLeadDetail,
	getLenderList,
	title,
	fetchLafData
}) => {
	const { state } = React.useContext(Context);
	const [comment, setComment] = React.useState('');
	const [errors, setErrors] = React.useState({});
	const [colenders, setColenders] = React.useState([]);
	const [lenderId, setLenderId] = React.useState('');
	const [leadAssignType, changeLeadAssignType] = React.useState(false);
	const [BREstatus, setBREstatus] = useState(false)
	const [BREstatusMessage, setBREstatusmessage] = useState('')
	const [BREdata, setBREdata] = useState([])
	const [showDetails, setshowDetails] = useState(false)
	const [checkhandler, setCheckhandler] = useState(BREstatus)
	const [lenderName, setlenderName] = useState("")
	const [finalResult, setFinalResult] = useState("")
	const [checkBREelegible, setcheckBREelegible] = useState(null)
	const [loader, setLoader] = useState(false)
	const param = useParams()
	const leadId = param.id
	React.useEffect(() => {
		getAssignLenders();
	}, []);
	const getAssignLenders = async () => {
		let response;
		if (bulkAssign) {
			response = await MasterDataService.getLenderList(
				state.userType,
				state.userType === 'admin' ? 'co-lender' : ''
			);
		} else {
			response = await LenderUgroService.getCoLenders({
				type: state.userType,
				leadId: selectedIds[0],
			});
		}

		if (response?.data?.status?.code === 1) {
			if (bulkAssign) {
				setColenders(
					objectsForEach(response?.data?.data?.lender_list, 'STRING_VAL').map(
						({ id, value }) => ({
							cl_lender_id: id,
							lender: { lender_name: value },
						})
					)
				);
			} else {
				setColenders(response?.data?.data?.coLenders);
			}
		}
	};

	const checkBRElender = async (leadId, lender_id) => {
		let response;
		response = await MasterDataService.checkBREstatus(
			state.userType,
			state.userType === 'admin' ? 'co-lender' : '',
			leadId,
			lender_id
		);
		if (response?.data?.status?.code === 1) {
			if (!response?.data?.data?.is_eligible) {
				setCheckhandler(false)
			}
			if (response?.data?.data?.data.length == 0) {
				setBREdata(response?.data?.data?.data)
			} else {
				setBREdata(response?.data?.data?.data?.data?.rules_result)
			}
			setlenderName(response?.data?.data?.lender_name)
			setBREstatus(response?.data?.data?.is_eligible)
			setBREstatusmessage(response?.data?.messages?.success?.others[0].split('.')[0])
			setFinalResult(response?.data?.data?.data?.data?.final_result)
		}
	};

	const assignLender = async () => {
		setLoader(true)
		try {
			let response;
			if (bulkAssign) {
				response = await LenderUgroService.bulkLeadSubmit({
					leadIds: selectedIds.map((lead) => lead.cl_lead_id),
					lenderId,
					comment,
				});
			} else {
				response = await LenderUgroService.assignLender({
					type: state.userType,
					requestBody: {
						lender_id: lenderId,
						...(leadType === 2 && {
							lead_assign_as_type: leadAssignType ? 1 : 2,
						}),
						cl_lead_id:
							type === 'details' ? selectedIds : formatLafIds('cl_lead_id'),
						comment: comment,
						BRE_status: checkBREelegible,
					},
				});
			}
			if (response?.data?.status?.code === 1) {
				let success = objectsForEach(
					response?.data?.data?.result,
					'STRING_VAL'
				);
				success = success.filter(({ value }) => value);
				if (success.length) {
					getLenderList()
					toast.success(
						<ol>
							{success.map(({ id, value }) => (
								<li>
									{splitUnderscoreToCaptialise(id)} - {value}
								</li>
							))}
						</ol>
					);
				} else {
					const successMessage = response?.data?.messages?.success;
					getLenderList()
					toggleModal();
					toast.success(
						successMessage?.form?.[0] ||
						successMessage?.others?.[0] ||
						message.SAVED_SUCCESS
					);
				}
				if (reloadTable) reloadTable(selectedIds[0]);
				getLeadDetail(lenderId)
				// fetchLafData()
				getLenderList()
				toggleModal();
				setLoader(false)
			}
		} catch (err) {
			let error = err?.response?.data?.messages?.error;
			toast.error(error?.form?.[0] || error?.others?.[0]);
			setErrors(error);
			setLoader(false)
		}
		setLoader(false)
	};

	const formatLafIds = (key) => {
		return selectedIds.map((id) => id[key]);
	};

	const formSubmitHandler = (e) => {
		e.preventDefault();

		assignLender(bulkAssign);
	};
	const CheckBREstatus = (lender_id) => {
		if (lender_id) {
			checkBRElender(leadId, lender_id)
		} if (lender_id === '') {
			setBREstatusmessage(null)
		}

	}
	const handleCheckbox = (e) => {
		setCheckhandler(!checkhandler)
		setcheckBREelegible(1)
	}
	useEffect(() => {
		setCheckhandler(BREstatus)
	}, [BREstatus])

	return (
		<Modal
			style={{
				minWidth: "20%",
				padding: "0px",
				backgroundColor: "transparent",
				width: '550px'
			}}
			state={modelState}
			closeModal={toggleModal}
			removeBorderSpace={true}
		>
			{' '}
			<>
				{!showDetails && <form onSubmit={formSubmitHandler}>
					<div className='form-group mb-0'>
						{Boolean(bulkAssign) && (
							<div className='row'>
								<div className='col-12'>
									<label>
										Total {selectedIds.length} Accounts have been selected :{' '}
									</label>
								</div>
								<div className='col-12'>
									<label>LAF ID : {formatLafIds('laf_id').join(', ')}</label>
								</div>
							</div>
						)}
					</div>

					{leadType === 2 && (
						<div className='d-flex flex-row justify-content-between'>
							<div>
								<input
									checked={leadAssignType}
									onChange={(e) => changeLeadAssignType(e.target.checked)}
									type='checkbox'
								/>
								<label className='ml-2'>Convert to Option 1</label>
							</div>
						</div>
					)}
					<div className="modal-header-container">
						<div className="modal-title">{title}</div>
						<div className="closeModalView" onClick={toggleModal}>
							<span className="closeModalIcon">x</span>
						</div>
					</div>
					<div className='p-4 modalData'>
						<h6 className='mb-2 '>
							<b>
								<small>Assign to</small>
							</b>
						</h6>
						<div className='form-group mb-0'>
							<div className='custom_control d-flex flex-wrap'>
								<select
									name='entity-type'
									onChange={(e) => setLenderId(e.target.value)}
									onClick={() => CheckBREstatus(lenderId)}
									value={lenderId}
								>
									<option value={''}>Select</option>
									{(colenders || []).map(({ lender, cl_lender_id }) => (
										<option
											className='custom_radio_control mr-4'
											value={cl_lender_id}
											key={cl_lender_id}

										>
											{lender.lender_name}
										</option>
									))}
								</select>
							</div>
							{errors && (
								<p className='mt-2 mb-0 text-danger'>
									{errors?.fields?.lender_id?.[0]}
								</p>
							)}
						</div>

						<div className='form-group'>
							<label>Remark</label>

							<textarea
								className='form-control custom-form-control'
								cols={4}
								rows={4}
								value={comment}
								onChange={(e) => setComment(e.target.value)}
								defaultValue={''}
							/>
							{errors && (
								<p className='mt-2 mb-0 text-danger'>
									{errors?.fields?.comment?.[0]}
								</p>
							)}
						</div>
						{BREstatus == false && (BREstatusMessage && <div class="form-check text-center">
							<input class="form-check-input" type="checkbox" value="" onChange={handleCheckbox} checked={checkhandler} />
							<label class="form-check-label my-1 cursor-pointer" style={{ cursor: "pointer" }} >
								<span style={{ color: "red" }}>{`${BREstatusMessage}`}{', for details '}</span>
							</label>
							<Link class="form-check-label my-1 cursor-pointer mx-1" style={{ cursor: "pointer" }} onClick={() => setshowDetails(true)}>
								click here
							</Link>
						</div>)}

						<div className='d-flex justify-content-center align-items-center'>
							<button type='submit' className='btn btn-custom'
								disabled={!checkhandler || loader}>
								{loader ? <div className='loader'></div> : "OK"}
							</button>
							<button
								type='button'
								className='btn btn-outline-custom ml-2'
								data-dismiss='modal'
								onClick={toggleModal}
							>
								Cancel
							</button>
						</div>
					</div>
				</form>}

				{/* other modal */}
				{showDetails && Object.entries(BREdata).length !== 0 ? (
					<div>
						<div className="modal-header-container">
							<div className="modal-title">{'Policy Parameter'}</div>
							<div className="closeModalView" onClick={() => {
								setshowDetails(!showDetails);
							}}>
								<span className="closeModalIcon">x</span>
							</div>
						</div>
						<div style={{ fontSize: "14px", fontWeight: 500, textAlign: "center", marginTop: "8px" }}>
							{lenderName}
						</div>
						<div style={{ fontSize: "14px", fontWeight: 500, textAlign: "center", marginTop: "6px" }}>
							Overall Result : {finalResult ? <span style={{ color: "green" }}>True</span> : <span style={{ color: "red" }}>False</span>}
						</div>
						<br />
						<div>
							<div
								style={{
									display: "grid",
									gridTemplateColumns: "34% 34% 34%",
									padding: " 3px 1rem",
									gap: "30px",
									alignItems: "center",
								}}
							>

								<div style={{ fontSize: "13px", fontWeight: 500 }}>
									Parameter
								</div>
								<div style={{ fontSize: "13px", fontWeight: 500 }}>
									{" "}
									Parameter Value
								</div>
								<div style={{ fontSize: "13px", fontWeight: 500 }}>
									{" "}
									Status
								</div>
							</div>

							<div style={{ maxHeight: "300px", overflowY: "auto", overflowX: "clip", paddingBottom: "15px" }}>
								{BREdata?.application && <div className="col mb-1">
									<div className="row">
										<div className="col-4">
											<hr />
										</div>
										<div className="col-4 text-center">
											<span className="font-weight-bold">Applicant</span>
										</div>
										<div className="col-4">
											<hr />
										</div>
									</div>
									{Object.entries(BREdata?.application?.varResult)?.map(([key, value]) => {
										return (
											<div
												style={{
													display: "grid",
													gridTemplateColumns: "34% 34% 34%",
													marginTop: "4px",
													gap: "30px",
													alignItems: "center",
													fontSize: "12.5px",
													fontWeight: "400",
												}}
											>
												<div style={{ wordWrap: "break-word" }}>{key}</div>
												<div style={{ marginLeft: "15%" }}>
													{/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
													<BREhelper value={value} />
												</div>
												{/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
												<span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}1`} data-tip></i></span> </span>
												<ReactTooltip id={`${key}1`} >{value?.message}</ReactTooltip>
											</div>
										);
									})}
								</div>}
								{BREdata?.commercial_bureau && <div className="col mb-1 ">
									{Object.entries(BREdata?.commercial_bureau?.varResult)?.map(([key, value]) => {
										return (
											<div
												style={{
													display: "grid",
													gridTemplateColumns: "34% 34% 34%",
													marginTop: "4px",
													gap: "30px",
													alignItems: "center",
													fontSize: "12.5px",
													fontWeight: "400",
												}}
											>
												<div style={{ wordWrap: "break-word" }}>{key}</div>
												<div style={{ marginLeft: "15%" }}>
													{/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
													<BREhelper value={value} />
												</div>
												{/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
												<span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}2`} data-tip></i></span> </span>
												<ReactTooltip id={`${key}2`} >{value?.message}</ReactTooltip>
											</div>
										);
									})}
								</div>}
								{BREdata?.consumer_bureau && <div className="col mb-1">
									<div className="row">
										<div className="col-4">
											<hr />
										</div>
										<div className="col-4  text-center">
											<span className="font-weight-bold">Co-Applicant</span>
										</div>
										<div className="col-4">
											<hr />
										</div>
									</div>
									{Object.entries(BREdata?.consumer_bureau?.varResult)?.map(([key, value]) => {
										return (
											<div
												style={{
													display: "grid",
													gridTemplateColumns: "34% 34% 34%",
													marginTop: "4px",
													gap: "30px",
													alignItems: "center",
													fontSize: "12.5px",
													fontWeight: "400",
												}}
											>
												<div style={{ wordWrap: "break-word" }}>{key}</div>
												<div style={{ marginLeft: "15%" }}>
													{/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
													<BREhelper value={value} />
												</div>
												{/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
												<span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}3`} data-tip></i></span> </span>
												<ReactTooltip id={`${key}3`} >{value?.message}</ReactTooltip>
											</div>
										);
									})}
								</div>}
								{BREdata?.banking && <div className="col mb-1">
									<div className="row">
										<div className="col-4">
											<hr />
										</div>
										<div className="col-4  text-center">
											<span className="font-weight-bold">Banking</span>
										</div>
										<div className="col-4">
											<hr />
										</div>
									</div>
									{Object.entries(BREdata?.banking?.varResult)?.map(([key, value]) => {
										return (
											<div
												style={{
													display: "grid",
													gridTemplateColumns: "34% 34% 34%",
													marginTop: "4px",
													gap: "30px",
													alignItems: "center",
													fontSize: "12.5px",
													fontWeight: "400",
												}}
											>
												<div style={{ wordWrap: "break-word" }}>{key}</div>
												<div style={{ marginLeft: "15%" }}>
													{/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
													<BREhelper value={value} />
												</div>
												{/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
												<span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}3`} data-tip></i></span> </span>
												<ReactTooltip id={`${key}3`} >{value?.message}</ReactTooltip>
											</div>
										);
									})}
								</div>}
								{BREdata?.karza_gstin && <div className="col mb-1">
									<div className="row">
										<div className="col-4">
											<hr />
										</div>
										<div className="col-4  text-center">
											<span className="font-weight-bold">GSTIN</span>
										</div>
										<div className="col-4">
											<hr />
										</div>
									</div>
									{Object.entries(BREdata?.karza_gstin?.varResult)?.map(([key, value]) => {
										return (
											<div
												style={{
													display: "grid",
													gridTemplateColumns: "34% 34% 34%",
													marginTop: "4px",
													gap: "30px",
													alignItems: "center",
													fontSize: "12.5px",
													fontWeight: "400",
												}}
											>
												<div style={{ wordWrap: "break-word" }}>{key}</div>
												<div style={{ marginLeft: "15%" }}>
													{/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
													<BREhelper value={value} />
												</div>
												{/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
												<span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}3`} data-tip></i></span> </span>
												<ReactTooltip id={`${key}3`} >{value?.message}</ReactTooltip>
											</div>
										);
									})}
								</div>}
							</div>
						</div>
					</div>
				) : (
					<>{(showDetails && BREdata.length == 0) && <div>	<div
						style={{
							backgroundColor: "white",
							boxShadow: 24,
							zIndex: 9,
							padding: "-10px",
							backdropFilter: "blur(5px)",
							width: "100%",
							height: "100%",
							borderRadius: "15px",
						}}
					>
						<div className="float-right">
							<button
								type="button"
								data-dismiss="modal"
								onClick={() => {
									setshowDetails(!showDetails);
								}}
								style={{
									fontSize: "10px",
									fontWeight: 500,
									marginBottom: "10px",
									cursor: "pointer",
									color: "white",
									paddin: "3px",
									border: "transparent",
									backgroundColor: "#ea652b",
									marginBottom: '10px',
									marginRight: '10px',
									marginTop: '7px',
									boxShadow: '1px 1px 6px 1px rgb(0 0 0 / 20%)',
									padding: '1px 5px',
									borderRadius: '50%'
								}}
							>
								<span className="fs-6">X</span>
							</button>
						</div>
						<div
							style={{
								fontSize: "14px",
								fontWeight: 500,
								marginBottom: "10px",
								width: "100%",
								padding: "5px",
								color: "white",
								backgroundColor: "#ea652b",
								marginTop: '0px',
								borderTopLeftRadius: "15px",
								borderTopRightRadius: "15px",
							}}
						>
							Policy Parameters
						</div>
						<div style={{ fontSize: "20px", fontWeight: 500, textAlign: "center" }}>
							{lenderName}
						</div>
						<div style={{ fontSize: "18px", fontWeight: 700, textAlign: "center" }}>
							No result found
						</div>
					</div>
					</div>}</>
				)}
			</>
		</Modal>
	);
};

export default AssignLenderLeadModal;

